import { Checkbox, DatePicker, Popover, Tooltip } from "antd";
import { clientRoles } from "constants/phase";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import SVG from "../SVG";
import styles from "./style.module.scss";

const FilterPopover = ({
  dateRange,
  setDateRange,
  isModalOpen,
  fetch,
  setIsModalOpen,
  isUserComponent,
  activePage,
  setActivePage,
}) => {
  const { RangePicker } = DatePicker;
  const handleDateRange = (val) => {
    val ? setDateRange(val) : setDateRange([]);
  };
  const [searchParams, setSearchParams] = useSearchParams();
  let updatedSearchParams = new URLSearchParams(searchParams.toString());
  const [selectedRoles, setSelectedRoles] = useState([]);
  useEffect(() => {
    let date = null;
    let paramRoles = [];
    if (updatedSearchParams.get("dateRange") !== null) {
      date = updatedSearchParams.get("dateRange")?.split(",");
      date = date?.map((date) => moment(date));
      setDateRange(date);
    }
    if (updatedSearchParams.get("roles")) {
      paramRoles = updatedSearchParams?.get("roles")?.split(",");
      setSelectedRoles(paramRoles);
    }

    if (isUserComponent) {
      fetch({ page: activePage, dateRange: date, roles: paramRoles });
    } else {
      fetch({ page: activePage, dateRange: date });
    }
  }, [searchParams, activePage]);

  return (
    <Tooltip placement="top" title={"More Actions"} arrow>
      <Popover
        open={isModalOpen}
        onOpenChange={setIsModalOpen}
        overlayStyle={{ borderRadius: "4px", padding: "12px 10px" }}
        content={
          <div>
            <div className="react-modal-header">
              <h5 className="react-modal-title">Filters</h5>
            </div>
            <div className="react-modal-footer">
              {isUserComponent && (
                <div
                  // className="content-control-block long styled-scroll"
                  className="page-toolbar-styled-item"
                  style={{
                    transition: "box-shadow 0.3s",
                    height: "auto",
                    width: "100%",
                    overflow: "auto",
                    marginTop: 10,
                  }}
                >
                  <div className="custom-radio-group pt-2">
                    <Checkbox.Group
                      className="text-capitalize"
                      value={selectedRoles}
                      defaultValue={[]}
                      onChange={(e) => {
                        if (e.includes("all") && !selectedRoles.includes("all")) {
                          setSelectedRoles(["all", ...Object.values(clientRoles)]);
                        } else if (e.includes("all") && selectedRoles.includes("all")) {
                          setSelectedRoles(e.filter((role) => role !== "all"));
                        } else if (!e.includes("all") && selectedRoles.includes("all")) {
                          setSelectedRoles([]);
                        } else if (e.length === Object.values(clientRoles).length && !e.includes("all")) {
                          setSelectedRoles(["all", ...Object.values(clientRoles)]);
                        } else {
                          setSelectedRoles(e);
                        }
                      }}
                    >
                      <Checkbox checked={selectedRoles.includes("all")} value="all" key="all">
                        All
                      </Checkbox>
                      {clientRoles &&
                        Object.entries(clientRoles).map(([_, value]) => {
                          return (
                            <Checkbox value={value} key={value}>
                              {value.charAt(0).toUpperCase() + value.slice(1)}
                            </Checkbox>
                          );
                        })}
                    </Checkbox.Group>
                  </div>
                </div>
              )}
              <div className="page-toolbar-styled-item">
                <div className="read-modal-title">Created Between</div>
                <div>
                  <div className="addCustom-date">
                    <RangePicker
                      ranges={{
                        Today: [moment(), moment()],
                        "This Month": [moment().startOf("month"), moment().endOf("month")],
                      }}
                      value={dateRange}
                      onChange={(val) => {
                        handleDateRange(val);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="react-modal-footer">
              <div className="page-toolbar-styled-item">
                <button
                  onClick={() => {
                    setIsModalOpen(false);
                  }}
                  className="btn btn-white btn-filters"
                >
                  Cancel
                </button>
              </div>
              <div className="page-toolbar-styled-item">
                <button
                  onClick={() => {
                    setActivePage(1);
                    setIsModalOpen(false);
                    if (dateRange && dateRange.length) {
                      updatedSearchParams.set("dateRange", dateRange);
                    } else {
                      updatedSearchParams.delete("dateRange");
                    }
                    if (isUserComponent) {
                      updatedSearchParams.set("roles", selectedRoles);
                    }
                    setSearchParams(updatedSearchParams);
                  }}
                  className="btn btn-primary btn-filters"
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
        }
        placement="bottomRight"
        open={isModalOpen}
        trigger="click"
        showArrow={false}
      >
        <div
          className={styles.filterIcon}
          onClick={() => {
            setIsModalOpen((current) => !current);
          }}
        >
          <SVG iconName={"images/filter-icon.svg"} />
        </div>
      </Popover>
    </Tooltip>
  );
};

export default FilterPopover;
